import { formatObjToParamStr, getUrlParams, isAlipayMiniProgramBrowser } from './common-helper';
import { logAddressURL } from '../config';
import wxMiniprogrameHelper from './wx-miniprogram-helper';

const interceptor = {
  handlers: {},

  add(url, handler) {
    const urls = [].concat(url);

    urls.forEach(item => {
      this.handlers[item] = handler;
    });
  },

  exec(url, params, ...rest) {
    const fixedUrl = url
      .replace(/^https?:\/\//, '')
      .split('/')
      .slice(1)
      .join('/');

    const handler = this.handlers[`/${fixedUrl}`];
    if (!handler || !wxMiniprogrameHelper.isMiniProgramMode() || !wxMiniprogrameHelper.isNewMiniprogram()) {
      return false;
    }

    handler(url, params, ...rest);

    return true;
  },
};

// 支付页
interceptor.add('/shop/payDetail', (url, params) => {
  wxMiniprogrameHelper.navigateTo('/pages/pay/checkout', params);
});

// 登录页
interceptor.add(['/user/notLogin', '/user-login.html'], (url, params, method = 'navigateTo') => {
  wxMiniprogrameHelper[method]('/pages/login/index', params);
});

const pageHelper = {
  navigateTo(url, params) {
    // TODO: 暂时屏蔽掉拦截器。所有都还是走h5
    if (interceptor.exec(url, params) === true) {
      return;
    }
    console.log('--------navigateTo', url);
    location.href = `${url}?${formatObjToParamStr(params)}`;
  },

  redirectWhenInit() {
    const params = getUrlParams();

    return interceptor.exec(location.pathname, params, 'redirectTo');
  },

  navigateToLoginPage(params) {
    try {
      // 此处接入支付宝小程序
      if (isAlipayMiniProgramBrowser()) {
        require('./ali-miniprogram-helper').aliPageHelper.navigateToLoginPage(params);
        return;
      }

      const tableId = sessionStorage.getItem('tableId');
      let tableQuery = '';
      if (tableId) {
        tableQuery = `&tableId=${tableId}`;
      }

      const finalParams = {
        returnUrl: encodeURIComponent(`${location.href}${tableQuery}`),
        ...params,
      };

      this.navigateTo(logAddressURL, finalParams);
    } catch (ex) {
      console.log('--------navigateToLoginPage ex', ex);
    }
  },
};

export default pageHelper;



// WEBPACK FOOTER //
// ./src/helper/page-helper.js